import axios from 'axios'

const state = {
    categories: [],
    active: null,
}

const getters = {
    categories: state => state.categories,
    active: state => state.active,
}

const actions = {
    async createCategory({ commit }, data) {
        const response = await axios.post(`${process.env.VUE_APP_NODE_API_HOST}/categories`, data.categoryData)

        commit('CREATE_CATEGORY', response.data.data)
        commit('SET_CATEGORY', response.data.data)

        return response.data.data
    },

    async getCategories({ commit }, projectId) {
        const response = await axios.get(process.env.VUE_APP_NODE_API_HOST + `/categories?projectId=${projectId}&page=1&limit=100&ascending=0`)

        commit('SET_CATEGORIES', response.data.data)

        return response.data.data
    },
}

const mutations = {
    SET_CATEGORIES(state, categories) {
        state.categories = categories
    },
    SET_CATEGORY(state, category) {
        state.active = category
        localStorage.activeCategoryId = category ? category.id : undefined
    },
    CREATE_CATEGORY(state, category) {
        state.categories.push(category)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
